export default __webpack_public_path__ + "static/OpenSans-Regular-99c9a48be684203fdf570e8afd4d12f9.woff2";